import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(t("auth.login_success"));
      navigate(u.role === "admin" ? "/admin" : "/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("auth.login_error"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24" data-testid="login-page">
      <div className="text-xs font-bold uppercase tracking-[0.3em] text-[#C5CDD8]">{t("auth.account")}</div>
      <h1 className="font-display mt-3 text-4xl font-bold uppercase tracking-tighter text-white">{t("auth.login_title")}</h1>

      <form onSubmit={submit} className="mt-10 space-y-6" data-testid="login-form">
        <label className="block">
          <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#C5CDD8]">{t("auth.email")}</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-2 w-full border-b border-white/40 bg-transparent text-white px-0 py-2 text-sm focus:outline-none focus:border-white"
            data-testid="login-email"
          />
        </label>
        <label className="block">
          <span className="text-[10px] font-bold uppercase tracking-[0.25em] text-[#C5CDD8]">{t("auth.password")}</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-2 w-full border-b border-white/40 bg-transparent text-white px-0 py-2 text-sm focus:outline-none focus:border-white"
            data-testid="login-password"
          />
        </label>
        <button
          type="submit"
          disabled={loading}
          className="w-full border border-white bg-white text-[#001F3F] hover:bg-transparent hover:text-white transition-all uppercase tracking-[0.25em] text-xs font-bold py-4 disabled:opacity-60"
          data-testid="login-submit"
        >
          {loading ? t("auth.signing_in") : t("auth.submit_login")}
        </button>
        <div className="text-center">
          <Link
            to="/forgot-password"
            className="text-[11px] uppercase tracking-[0.25em] text-white/55 hover:text-white underline-offset-4 hover:underline"
            data-testid="goto-forgot-password"
          >
            Mot de passe oublié ?
          </Link>
        </div>
        <p className="text-sm text-center text-white/60">
          {t("auth.no_account")}{" "}
          <Link to="/register" className="text-white font-bold underline" data-testid="goto-register">
            {t("auth.register_link")}
          </Link>
        </p>
      </form>
    </div>
  );
}
